
import React from 'react';

export const ChevronDoubleRightIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    keyboard_double_arrow_right
  </span>
);